import {
    Checkbox,
    Dropdown,
    Icon,
    PrimaryButton,
    Stack,
    TextField,
    Calendar,
    defaultCalendarStrings,
    SearchBox,
    mergeStyleSets,
    DatePicker,
    TooltipHost,
  } from "@fluentui/react";
import React,{useContext,useEffect,useRef,useState} from "react";
import studylistContext from "../../../../context/studylist/StudylistContext";
import { FILTER_TYPE, HIDE_FILTER_FOR_ROLES, HIDE_PRIORITY_FILTER, REPORTED_SUBTABS_ID, STUDY_SEARCH_RESULTS_ID, USERTYPES } from "../../../../constants/Constants";
import { t } from "i18next";
import loaderContext from "../../../../context/loader/LoaderContext";
import Moment from "moment";
import themeContext from "../../../../context/theme/ThemeContext";
import userContext from "../../../../context/users/UserContext";
import { NO_OF_IMAGES_STATUS } from "../../../../constants/Constants";
import { getEnv } from '../../../../helpers/EnvHelper';
import { getRadiologistDisplayName } from "../../../../helpers/CommonUtility";
import { T } from "@kitware/vtk.js/macros2";
import DateRangePicker from "./DateRangePicker/DateRangePicker";
import MultiSelectFilterList from "./MultiSelectFilterList/MulitiSelectFilterList"
import { hasGlobalSearchCriteria } from "../../helpers/globalSearchHelpers";

const FilterPopUp = (props) => {
    const { themeName } = useContext(themeContext);
    const {
        setAllStudies,
        studyData,
        columns,
        allStudies,
        searchDto,
        setSearchDto,
        sortGlobal,
        setSortGlobal,
        filterInputValues,
        showFilters,setShowFilters,
        storefilterInputValues,
        setStoreFilterInputValues,
        setFilterInputValues,
        setModalityIds,
        setSubModalityIds,
        setClientOrFirmIds,
        setUploadDate,
        setPathology,
        setPriority,
        setStudyPriorityValues,
        setProviderIds,
        setStudyDate,
        roles,
        setTrackApplyButton,
        trackApplyButton,
        setPatientNameBadgeShow,
        setApplyClick,
        handleRefresh,
        beginGlobalSearchSessionIfNeeded,
        promptEmptyGlobalSearch,
        setGlobalSearchEmptyMessage,
        handleDesktopClearFilter,
        setStudyDateFrom,studyDateFrom,
        studyDateTo,setStudyDateTo,
        reportDateFrom, setReportDateFrom, 
        reportDateTo, setReportDateTo,
        setReportDate,
        studyListSearchDateFilterValue,
        setClassificationIds,
        uploadDateRange,
        setNoOfImagesIds,
        setHistoryIds,
        selectedValue,
        setFilterBadges,
      } = useContext(studylistContext);

      const [selectFromDate, setSelectedFromDate] = useState('');
      const { enableButtonTourPurpose,setEnableButtonTourPurpose } = useContext(loaderContext); 
      
      const {qcOutsourceLogin, username,priorityLabels} = useContext(userContext);

      const ref = useRef(null);
      const { onClickOutside } = props;

      useEffect(() => {
        const handleClickOutside = (event) => {
          if (ref.current && !ref.current.contains(event.target)) {
            if (event.target.closest && event.target.closest(".ms-Callout")) return;
            onClickOutside && !enableButtonTourPurpose.showFilterPopup && onClickOutside();
          }
        };
        document.addEventListener("click", handleClickOutside, true);
        return () => {
          document.removeEventListener("click", handleClickOutside, true);
        };
      }, [onClickOutside]);

      if (!props.show) return null;


    
    

  
  const calendarStyle = {
    root: {
      color: "#A19F9D",
      background: "transparent"
    },
    goTodayButton: {
      color: "#A19F9D",
    },
    headerIconButton: {
      color: "#A19F9D",
    },
    daySelected: {
      background: "#5A5A5A"
    },
    dayIsToday : {
      background: "red"
    },
    liveRegion : {
      color: "#A19F9D"
    },
    weekDayLabelCell : {
      paddingLeft: "2px"
    }
  
  };

  
  const checkboxStyle = {
    root: {
      margin: "10px 0",
    },
    text: {
      fontWeight: "400",
      fontSize: "14px"
    },
    checkbox: {
    },
  };

  const searchStyle = {
    root: {
      background: themeName === "light"?"white":"black",
    },
    field: {
      fontSize: '12px',
      lineHeight: '16px'
    }
  };

  const getProviderSelectionKey = (radiologist) =>
    ((radiologist.firstName == null || radiologist.firstName == undefined) ? "F" : "R") + radiologist.id;

  const filterList = (searchInput,searchFilterType) => {
    if(searchInput != null && searchInput != undefined)searchInput = searchInput.trim();
    let searchValue = searchInput.toLowerCase();
    let allTemp = storefilterInputValues[searchFilterType];
    if (searchValue != "") {
      const filteredData = allTemp.filter((item) => {
        if(searchFilterType == "radiologistList"){
          return getRadiologistDisplayName(item).toLowerCase().includes(searchValue);
        }
        if(searchFilterType == "subModalityList"){
          return item.serviceName.toLowerCase().includes(searchValue);
      }
        return item.name.toLowerCase().includes(searchValue);
      });
       setFilterInputValues(()=>{
          const newItem = {...filterInputValues};
          newItem[searchFilterType] = filteredData;
          return newItem;
       })
    } else {
      setFilterInputValues(()=>{
        const newItem = {...filterInputValues};
        newItem[searchFilterType] = storefilterInputValues[searchFilterType];
        return newItem;
     })
    }
  };

  const calendarStyles = mergeStyleSets({
    wrapper: {
      display: 'inline-block',
    },
  });

  

  const priorityList = [
    {key: "Critical", text: t("study-list.filters.critical")},
    {key: "High", text: t("study-list.filters.high")},
    {key: "Low", text: t("study-list.filters.low")},
    {key: "Medium", text:  t("study-list.filters.medium")},
    {key: "No AI Output", text:  t("study-list.filters.no-ai-output")},
    {key: "Results Awaited", text:  t("study-list.filters.result-awaited")},
    {key: "Non Frontal Chest", text: t("study-list.filters.non-frontal")},
    {key: "Suspect", text: t("study-list.filters.suspect")},

  ]

   const getPriorityLabel = (key, fallback) =>
   priorityLabels?.find((p) => p.key === key)?.label || fallback;

  const studyPriorityList = [
    { id: "EMERGENCY", name: getPriorityLabel("EMERGENCY", "Emergency") },
    { id: "NON_MEDICAL_EMERGENCY", name: getPriorityLabel("NON_MEDICAL_EMERGENCY", "Non-Medical Emergency") },
    { id: "ROUTINE", name: getPriorityLabel("ROUTINE", "Routine") },
  ];
  const parseDateFromString = (newValue, previousValue) => {
    const newValueParts = (newValue || '').trim().split('/');
    const day =
      newValueParts.length > 0 ? Math.max(1, Math.min(31, parseInt(newValueParts[0], 10))) : previousValue.getDate();
    const month =
      newValueParts.length > 1
        ? Math.max(1, Math.min(12, parseInt(newValueParts[1], 10))) - 1
        : previousValue.getMonth();
    let year = newValueParts.length > 2 ? parseInt(newValueParts[2], 10) : previousValue.getFullYear();
    if (year < 100) {
      year += previousValue.getFullYear() - (previousValue.getFullYear() % 100);
    }
    return new Date(year, month, day);
  }
  
  const getSelectedDate = (value) => {
    console.log("--- Selected Date ----",value);
    if (value != null && value != undefined) {
      return Moment(value, 'DD-MMM-YYYY').toDate();
    }
    return studyDateFrom;
  }


    const isPortraitMode = window.innerHeight > window.innerWidth && window.innerWidth >= 800;
    const isHospitalUserOrDoc = roles.length > 0 && (roles[0] === USERTYPES.FIRMDOCTOR || roles[0] === USERTYPES.FIRMTECHNICIAN);

    return (
        <>

            <div data-tut={"tour-filter-popup"} className="filter-popup-study-list" style={{width:(isPortraitMode && isHospitalUserOrDoc)?"98%":(roles.length > 0 && HIDE_FILTER_FOR_ROLES.includes(roles[0]))?"84%":"99%",
            left: (isPortraitMode && isHospitalUserOrDoc)?"unset":(roles.length > 0 && HIDE_FILTER_FOR_ROLES.includes(roles[0]))?"12%":"unset",
            right: (roles.length > 0 && HIDE_FILTER_FOR_ROLES.includes(roles[0]))?"unset":"2px",
            zIndex: 10000 }
          }  ref={ref}>
       <div className="filter-scroll-wrapper">
              <div className="study-list-filter-popup-filters-section">

            <>
                <div></div>
                   {/* <div className="filter-section-seperator"></div> */}
                  <div className="align-filter-section filter-popup-child" style={{ width: "11%" }}>
                    <span className="filter-section-text">{t("navbar.no of images")}</span>
                     <SearchBox
                          placeholder="Search"
                          className="custom-disabled-search"
                          styles={{
                            ...searchStyle,
                             root: {
                               ...searchStyle.root,
                              cursor: 'not-allowed',
                            }
                          }}
                          onClear={(ev) => {
                          }}
                        />
                    <div className="modal-scroll study-list-filter-section" style={{
                      paddingLeft: '3px'}}>
                      {[
                        { id: NO_OF_IMAGES_STATUS.ZERO_NO_OF_IMAGES, name: "0" },
                        { id: NO_OF_IMAGES_STATUS.MORE_THAN_ZERO_NO_OF_IMAGES, name: "> 0" },
                      ].map((item) => (
                        <Checkbox
                          key={item.id}
                          label={item.name}
                          name={item.name}
                          styles={checkboxStyle}
                          checked={
                            searchDto.noOfImages !== null && 
                            searchDto.noOfImages !== undefined && 
                            (
                              Array.isArray(searchDto.noOfImages) 
                                ? searchDto.noOfImages.includes(item.id)
                                : searchDto.noOfImages === item.id
                            )
                          }
                          onChange={(e, data) => {
                            console.log("No of Images checkbox clicked:", {
                              itemId: item.id,
                              itemName: item.name,
                              checked: data,
                              currentValue: searchDto.noOfImages
                            });
                            
                            if (data) {
                              setNoOfImagesIds(item.name, item.id, true);
                            } else {
                              setNoOfImagesIds(item.name, item.id, false);
                            }
                          }}
                        />
                      ))}
                    </div>
                  </div>
                </>
                {(
                    <>
                      <div className="filter-section-seperator"></div>
                      <div className="align-filter-section filter-popup-child history-filter" style={{ width: "120px" }}>
                        <span className="filter-section-text">{t("navbar.history")}</span>

                         <SearchBox
                          placeholder="Search"
                          className="custom-disabled-search"
                          styles={{
                            ...searchStyle,
                            root: {
                              ...searchStyle.root,
                              cursor: 'not-allowed'
                            }
                          }}
                          onClear={(ev) => {
                          }}
                        />
                        
                        <div className="modal-scroll study-list-filter-section"  style={{
                      paddingLeft: '3px'}}>
                          {[
                            { id: 1, name: "Clinical Note Present" },
                            { id: 2, name: "Clinical Note Absent" },
                            { id: 3, name: "History Doc Present" },
                            { id: 4, name: "History Doc Absent" },
                            { id: 5, name: "Either Note or Doc" },
                            { id: 6, name: "No Note or Doc" },
                          ].map((item) => (
                           <Checkbox
                              key={item.id}
                              label={item.name}
                              name={item.name}
                               styles={{
                                ...checkboxStyle,
                                root: {
                                  ...checkboxStyle.root,
                                  margin: '4px 0', // Less vertical space
                                  paddingRight: '4px'
                                },
                                text: {
                                  ...checkboxStyle.text,
                                  padding: '2px 4px', // Compact text
                                  minWidth: 'auto'
                                }
                              }}
                              checked={
                                searchDto.historyChecks === item.id
                              }
                              onChange={(e, data) => {
                                if (data) {
                                  setHistoryIds(item.name, item.id, true);
                                } else {
                                  setHistoryIds(null, null, false);
                                }
                              }}
                            />
                          ))}
                        </div>
                      </div>
                    </>
                  )}

                  <div className="filter-section-seperator"></div>

              <div className="align-filter-section filter-popup-child modality-narrow">
                <span className="filter-section-text">{t("navbar.modality")}</span>
                <SearchBox
                    placeholder="Search"
                    styles={{
                      root: {
                        ...searchStyle.root,
                        width: '120px'      
                      }}}
                    onClear={(ev) => {
                      // console.log("Custom onClear Called");
                    }}
                    onChange={(ev, newValue) => {filterList(newValue,FILTER_TYPE.ModalityList );}}
                  />
                  <div
                  className="modal-scroll study-list-filter-section"  style={{
                      paddingRight: '4px', 
                      paddingLeft: '3px'
                    }} >
                  {filterInputValues.modalityList != undefined && (
                    <MultiSelectFilterList
                      items={Array.from(filterInputValues.modalityList)}
                      getItemId={(modality) => modality.id}
                      getItemLabel={(modality) => modality.name}
                      selectedIds={searchDto.modalityIds}
                      showAllOption={true}
                      checkboxStyles={{
                        ...checkboxStyle,
                        root: {
                          ...checkboxStyle.root,
                          margin: '4px 0',
                          paddingRight: '4px'
                        },
                        text: {
                          ...checkboxStyle.text,
                          padding: '2px 4px',
                          minWidth: 'auto'
                        }
                      }}
                      onItemToggle={(modality, id, checked) => setModalityIds(modality.name, id, checked)}
                      onSelectAllChange={(newIds) => {
                        const modalityList = Array.from(filterInputValues.modalityList || []);
                        const validIds = newIds.filter((id) =>
                          modalityList.some((m) => m.id === id)
                        );
                        const modalityBadges = modalityList
                          .filter((m) => validIds.includes(m.id))
                          .map((m) => ({ key: "modalityIds", label: m.name, value: m.id }));
                        setFilterBadges((prev) => [
                          ...prev.filter((b) => b.key !== "modalityIds"),
                          ...modalityBadges,
                        ]);
                        setSearchDto((prev) => ({ ...prev, modalityIds: validIds }));
                      }}
                    />
                  )}
                </div>
              </div>

              {(roles.length > 0) && roles[0] != USERTYPES.TYPIST && !qcOutsourceLogin && <div className="filter-section-seperator"></div>}
              { (roles.length > 0) && roles[0] != USERTYPES.TYPIST && !qcOutsourceLogin && <div className="client-filter-section filter-popup-child align-filter-section">
                <span className="filter-section-text">
                    {username === "djones"
                      ? t("navbar.projects")
                      : roles[0] === USERTYPES.ADMIN
                      ? t("navbar.firms")
                      : t("navbar.clients")}
                  </span>
                <SearchBox
                    placeholder="Search"
                    styles={searchStyle}
                    onClear={(ev) => {
                      // console.log("Custom onClear Called");
                    }}
                    onChange={(ev, newValue) => {filterList(newValue,FILTER_TYPE.ClientFirmList );}}
                  />
                <div
                  className="modal-scroll study-list-filter-section" style={{ 
                      paddingLeft: '3px'
                    }} >
                  
                  {filterInputValues.clientFirmList != undefined && (
                    <MultiSelectFilterList
                      items={Array.from(filterInputValues.clientFirmList)}
                      getItemId={(client) => client.id}
                      getItemLabel={(client) =>
                        client.name ? client.name.replace(/^(\__p_)/i, "") : "-"
                      }
                      selectedIds={searchDto.clientOrFirmIds}
                      showAllOption={true}
                      checkboxStyles={checkboxStyle}
                      onItemToggle={(client, id, checked) =>
                        setClientOrFirmIds(client.name, id, checked)
                      }
                      onSelectAllChange={(newIds) => {
                        const clientList = Array.from(filterInputValues.clientFirmList || []);
                        const validIds = newIds.filter((id) =>
                          clientList.some((c) => c.id === id)
                        );
                        const clientBadges = clientList
                          .filter((c) => validIds.includes(c.id))
                          .map((c) => ({ key: "clientOrFirmIds", label: c.name, value: c.id }));
                        setFilterBadges((prev) => [
                          ...prev.filter((b) => b.key !== "clientOrFirmIds"),
                          ...clientBadges,
                        ]);
                        setSearchDto((prev) => ({ ...prev, clientOrFirmIds: validIds }));
                      }}
                    />
                  )}
                  
                </div>
              </div>}
              {(roles.length > 0)&&(getEnv("REACT_APP_VDC_PLATFORM") == "true" ) &&<div className="filter-section-seperator"></div>}
              {getEnv("REACT_APP_VDC_PLATFORM") == "true" 
                && filterInputValues?.subModalityList != undefined
                && [USERTYPES.FIRMADMIN, USERTYPES.FIRMTECHNICIAN, USERTYPES.SUPERVISOR, USERTYPES.FIRMDOCTOR, USERTYPES.RADIOLOGIST,USERTYPES.TYPIST].includes(roles[0]) && (
                  <>
                    <div className="align-filter-section filter-popup-child sub-modality-narrow">
                      <span className="filter-section-text">Study Description</span>
                      <SearchBox
                        placeholder="Search"
                        styles={{ root: { ...searchStyle.root, width: '120px' } }}
                        onChange={(ev, newValue) => { filterList(newValue, FILTER_TYPE.SubModalityList); }}
                      />
                      <div className="modal-scroll study-list-filter-section" style={{ paddingRight: '4px', paddingLeft: '3px' }}>
                        {Array.from(filterInputValues.subModalityList).sort((a, b) => {
                            const searchText = document.querySelector('.sub-modality-narrow .ms-SearchBox-field')?.value?.toLowerCase() || '';
                            const aStartsWith = a.serviceName?.toLowerCase().startsWith(searchText);
                            const bStartsWith = b.serviceName?.toLowerCase().startsWith(searchText);
                            if (aStartsWith && !bStartsWith) return -1;
                            if (!aStartsWith && bStartsWith) return 1;
                            return 0;
                        }).map((item) => (
                          <TooltipHost content={item.serviceName} > 
                          <Checkbox
                            key={item.id}
                            label={item.serviceName}
                            name={item.serviceName}
                            styles={checkboxStyle}
                            checked={(searchDto.subModalityIds == null || searchDto.subModalityIds == undefined)
                              ? false
                              : searchDto.subModalityIds?.includes(item.id)}
                            onChange={(e, data) => setSubModalityIds(item.serviceName, item.id, data)}
                          />
                          </TooltipHost>
                        ))}
                        {filterInputValues?.subModalityList?.length == 0 && (
                          <span className="study-list-filter-no-record">No record found</span>
                        )}
                      </div>
                    </div>
                  </>
                )}
              {(roles.length > 0 && (( getEnv("REACT_APP_VDC_PLATFORM") == "true" && roles[0] === USERTYPES.TYPIST) || !HIDE_PRIORITY_FILTER.includes(roles[0]))) &&<div className="filter-section-seperator"></div>}
              <div className="upload-date-filter-section align-filter-section filter-popup-child"  style={{width:(roles.length > 0 && HIDE_FILTER_FOR_ROLES.includes(roles[0]) || !filterInputValues?.showAllStudies)?HIDE_FILTER_FOR_ROLES.includes(roles[0])?"22%":"15%":"11%"}}>
                <span className="filter-section-text ">{t("study-list.filters.created-date-range")}</span>
                <SearchBox
                    placeholder="Search"
                    className="custom-disabled-search"
                    styles={{
                      ...searchStyle,
                      root: {
                       ...searchStyle.root,
                        cursor: 'not-allowed'
                      }
                    }}
                    onClear={(ev) => {
                      // console.log("Custom onClear Called");
                    }}
                  />
                <div
                  className="modal-scroll study-list-filter-section"
                >
                  <ul className="upload-date-ul">
                    {Array.from(uploadDateRange).map((date,id) => {
                      return (
                        <li onClick={()=>setUploadDate(date)} className={`upload-date-li hover-list-view-tr  ${searchDto.uploadDate == date.key?"study-list-active-li":""}`} key={date.key}>
                          {date.text}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
              <div className="filter-section-seperator"></div>
                <>
                <div className="study-start-date-filter-section align-filter-section filter-popup-child-date"
                style={{width:(roles.length > 0 && HIDE_FILTER_FOR_ROLES.includes(roles[0]))?"24%":"204px"}}
                >
                  <DateRangePicker variant="study" />
                </div>
                </>
              {(roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.SUPERVISOR || roles[0] == USERTYPES.RADIOLOGIST || roles[0] == USERTYPES.FIRMTECHNICIAN || roles[0] == USERTYPES.FIRMDOCTOR ) && (REPORTED_SUBTABS_ID.includes(selectedValue) || selectedValue === STUDY_SEARCH_RESULTS_ID) &&
                <>
                <div className="filter-section-seperator"></div>
                <div className="study-report-start-date-filter-section align-filter-section filter-popup-child-date"
                style={{width:"15.5%"}}
                >
                  <DateRangePicker variant="report" />
                </div>
                </>
              }
              {(roles.length > 0 && !HIDE_FILTER_FOR_ROLES.includes(roles[0])) && <div className="filter-section-seperator"></div>}
              {(roles.length > 0 && !HIDE_FILTER_FOR_ROLES.includes(roles[0])) && <div  style={{width:(!filterInputValues?.showAllStudies)?"15%":"11%"}} className="pathology-filter-section align-filter-section filter-popup-child">
                <span className="filter-section-text">{t("navbar.findings")}</span>
                <SearchBox
                    placeholder={t("button.search")}
                    styles={searchStyle}
                    onClear={(ev) => {
                      // console.log("Custom onClear Called");
                    }}
                    onChange={(ev, newValue) => {filterList(newValue,filterInputValues?.xrayVersion && filterInputValues?.cxrAnalyserFlag ? FILTER_TYPE.ClassificationList : FILTER_TYPE.AnnotationList);}}
                  />
                <div
                  className="modal-scroll study-list-filter-section"
                >
                  <ul className="upload-date-ul">
                    {
                    // filterInputValues?.xrayVersion && filterInputValues?.cxrAnalyserFlag && filterInputValues?.classificationList != undefined  ? 
                    //   Array.from(filterInputValues?.classificationList).map((classification) => {
                    //     return (
                    //       <Checkbox
                    //         key={classification.id}
                    //         label={classification.name}
                    //         name={classification.name}
                    //         styles={checkboxStyle}
                    //         // defaultChecked = {searchDto.modalityIds?.includes(modality.id)}
                    //         checked = {(searchDto.classificationIds == null || searchDto.classificationIds == undefined) ? false : searchDto.classificationIds?.includes(
                    //           classification.id
                    //       )}
                    //         onChange={(e,data) => setClassificationIds(classification.name,classification.id,data)}
                    //       />
                    //     );
                    //   })
                    // : 
                    filterInputValues.annotationList != undefined &&
                      Array.from(filterInputValues.annotationList).map(
                        (pathology, index) => {
                          return (
                            <li  onClick={()=>setPathology(pathology)} className={`upload-date-li ${searchDto.annotationId == pathology.name?"study-list-active-li":""}`} key={index}>
                              {pathology.name}
                            </li>
                          );
                        }
                      )}
                      {filterInputValues?.annotationList?.length == 0 && <li className="study-list-filter-no-record">
                    No record found
                    </li>}
                  </ul>
                </div>
              </div>}
              {(roles.length > 0 && !HIDE_FILTER_FOR_ROLES.includes(roles[0])) &&<div className="filter-section-seperator"></div>}
              {(roles.length > 0 && !HIDE_FILTER_FOR_ROLES.includes(roles[0])) && <div className="priority-filter-section align-filter-section filter-popup-child"
               style={{width:(!filterInputValues?.showAllStudies)?"15%":"11%"}}
              >
                <span className="filter-section-text">{t("navbar.priority")}</span>
                <SearchBox
                    placeholder="Search"
                    styles={searchStyle}
                    onClear={(ev) => {
                      // console.log("Custom onClear Called");
                    }}
                    onChange={(ev, newValue) => {filterList(newValue,FILTER_TYPE.PriorityList );}}
                  />
                <div
                  className="modal-scroll study-list-filter-section"
                >
                 
                  <ul className="upload-date-ul">
                    {Array.from(priorityList).map((priority,id) => {
                      return (
                        <li onClick={()=>setPriority(priority)} className={`upload-date-li ${searchDto.aiPredictionId == priority.key?"study-list-active-li":""}`} key={priority.key}>
                          {priority.text}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>}

              {(roles.length > 0 && !HIDE_PRIORITY_FILTER.includes(roles[0])) &&<div className="filter-section-seperator"></div>}
              {(roles.length > 0 && !HIDE_PRIORITY_FILTER.includes(roles[0])) && <div className="study-priority-filter-section align-filter-section filter-popup-child"
               style={{width:(!filterInputValues?.showAllStudies)?"15%":"11%"}}
              >
                <span className="filter-section-text">{t("navbar.study-priority")}</span>
                <SearchBox
                    placeholder="Search"
                    className="custom-disabled-search"
                    styles={{
                      ...searchStyle,
                      root: {
                        ...searchStyle.root,
                        cursor: 'not-allowed'
                      }
                    }}
                    onClear={(ev) => {}}
                  />
                <div
                  className="modal-scroll study-list-filter-section" style={{
                      paddingLeft: '3px'
                   }} >
                  <MultiSelectFilterList
                    items={studyPriorityList}
                    getItemId={(item) => item.id}
                    getItemLabel={(item) => item.name}
                    selectedIds={searchDto.studyPriorityValues}
                    showAllOption={false}
                    checkboxStyles={checkboxStyle}
                    onItemToggle={(item, id, checked) => setStudyPriorityValues(item.name, id, checked)}
                    onSelectAllChange={(newIds) => {
                      const validIds = newIds.filter((id) =>
                        studyPriorityList.some((p) => p.id === id)
                      );
                      const priorityBadges = studyPriorityList
                        .filter((p) => validIds.includes(p.id))
                        .map((p) => ({ key: "studyPriorityValues", label: p.name, value: p.id }));
                      setFilterBadges((prev) => [
                        ...prev.filter((b) => b.key !== "studyPriorityValues"),
                        ...priorityBadges,
                      ]);
                      setSearchDto((prev) => ({ ...prev, studyPriorityValues: validIds }));
                    }}
                  />
                </div>
              </div>}
             {(roles.length > 0 && !filterInputValues?.showAllStudies) && <div className="filter-section-seperator"></div>}

              {(roles.length > 0 && filterInputValues?.showAllStudies) && <div className="filter-section-seperator"></div>}
              { filterInputValues?.showAllStudies && !qcOutsourceLogin && <div className="provider-filter-section align-filter-section filter-popup-child"
               style={{width:(roles.length > 0 && HIDE_FILTER_FOR_ROLES.includes(roles[0]))?"15%":"11%"}}
              >
                <span className="filter-section-text">{t("navbar.providers")}</span>
                <SearchBox
                    placeholder="Search"
                    styles={searchStyle}
                    onClear={(ev) => {
                      // console.log("Custom onClear Called");
                    }}
                    onChange={(ev, newValue) => {filterList(newValue,FILTER_TYPE.RadiologistList );}}
                  />
                <div
                  className="modal-scroll study-list-filter-section" style={{
                      paddingLeft: '3px'
                   }} >
                   
                  {filterInputValues.radiologistList != undefined && (
                     <MultiSelectFilterList
                       items={Array.from(filterInputValues.radiologistList)}
                       getItemId={(radiologist) => getProviderSelectionKey(radiologist)}
                       getItemLabel={(radiologist) => getRadiologistDisplayName(radiologist)}
                       selectedIds={searchDto.providerIds}
                       showAllOption={true}
                       checkboxStyles={checkboxStyle}
                       onItemToggle={(radiologist, _key, checked) =>
                         setProviderIds(radiologist, radiologist.id, checked)
                       }
                       onSelectAllChange={(newKeys) => {
                         const radiologistList = Array.from(filterInputValues.radiologistList || []);
                         const validKeys = newKeys.filter((key) =>
                           radiologistList.some((r) => getProviderSelectionKey(r) === key)
                         );
                         const providerBadges = radiologistList
                           .filter((r) => validKeys.includes(getProviderSelectionKey(r)))
                           .map((r) => ({
                             key: "providerIds",
                             label: getRadiologistDisplayName(r),
                             value: getProviderSelectionKey(r),
                           }));
                         setFilterBadges((prev) => [
                           ...prev.filter((b) => b.key !== "providerIds"),
                           ...providerBadges,
                         ]);
                         setSearchDto((prev) => ({ ...prev, providerIds: validKeys }));
                       }}
                      />
                    )}
                </div>
              </div>}
              </div>
            </div>
            <div className="study-list-filter-popup-button-section">
            <PrimaryButton
              text={t("button.apply")}
              onClick={() => {
                setTrackApplyButton(true);
                if (searchDto?.patientNameOrId?.length > 0) {
                  setPatientNameBadgeShow(true);
                }
                setFilterInputValues(storefilterInputValues);
                props.setShowFilterOptions(false);
                setApplyClick(true);
                if (hasGlobalSearchCriteria(searchDto)) {
                  setGlobalSearchEmptyMessage(null);
                }
                setTimeout(() => {
                  if (hasGlobalSearchCriteria(searchDto)) {
                    beginGlobalSearchSessionIfNeeded?.();
                  } else if (selectedValue === STUDY_SEARCH_RESULTS_ID) {
                    promptEmptyGlobalSearch?.();
                    beginGlobalSearchSessionIfNeeded?.();
                    return;
                  }
                  handleRefresh();
                }, 500);
              }}
          className={!trackApplyButton?"common-default-active-button":"common-default-inactive-button"}
        />
        <PrimaryButton
            text={t("button.cancel")}
            onClick={() =>{
              props.setShowFilterOptions(false);
              setStudyDateFrom(new Date());
              setStudyDateTo(new Date());
              setReportDateFrom(new Date());
              setReportDateTo(new Date());
              setFilterInputValues(storefilterInputValues);
              handleDesktopClearFilter()
              handleRefresh();
            }}
            //className="study-list-clear-all-button"
            style={{marginLeft: "10px"}}
          />
            </div>
       </div> 
           
          
          </>
    )
};

export default FilterPopUp;